import "./styles.css";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

import right_arrow from "../../assets/right_arrow.png";

const Form = () => {
  const formRef = useRef(null);
  const navigate = useNavigate();

  const id =
    "AKfycbykiCfyAxbVSJgemNZXO64ylz9III6-MDcOdGmbaqDaHy3baeVfrCBq4AD56w095l7Z_Q";
  const scriptURL = `https://script.google.com/macros/s/${id}/exec`;

  const phoneMask = (e) => {
    if (e.target.value.length < 10) {
      return alert("Número inválido");
    } else if (e.target.value.length === 10) {
      const x = e.target.value
        .replace(/\D/g, "")
        .match(/(\d{2})(\d{4})(\d{4})/);
      e.target.value = "(" + x[1] + ") " + x[2] + "-" + x[3];
    } else {
      const x = e.target.value
        .replace(/\D/g, "")
        .match(/(\d{2})(\d{5})(\d{4})/);
      e.target.value = "(" + x[1] + ") " + x[2] + "-" + x[3];
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    document.getElementById("submit").disabled = true;
    document.getElementById("submit").style.cursor = "default";
    document.getElementById("submit").style.opacity = 0.5;

    fetch(scriptURL, {
      method: "POST",
      body: new FormData(formRef.current),
    })
      .then(() => {
        document.getElementById("form").reset();
        navigate("/sucesso");
      })
      .catch((err) => console.log(err))
      .finally(() => {
        document.getElementById("submit").disabled = false;
        document.getElementById("submit").style.cursor = "pointer";
        document.getElementById("submit").style.opacity = 1;
      });
  };

  return (
    <form ref={formRef} name="google-sheet" onSubmit={handleSubmit} id="form">
      <div className="form-div1">
        <label htmlFor="name">
          <p>
            Nome da Empresa: <span>*</span>
          </p>
          <input type="text" id="name" name="Nome" required />
        </label>
        <label htmlFor="email">
          <p>
            E-mail: <span>*</span>
          </p>
          <input type="email" id="email" name="Email" required />
        </label>
        <label htmlFor="tel">
          <p>
            (DDD) + Telefone: <span>*</span>
          </p>
          <input
            type="tel"
            id="tel"
            name="Telefone"
            onBlur={phoneMask}
            minLength="10"
            maxLength="11"
            required
          />
        </label>

        <button type="submit" id="submit">
          Enviar Agora
          <img src={right_arrow} alt="Seta para direita" />
        </button>
      </div>
    </form>
  );
};

export default Form;
